import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

export const StaffEntitlementTable = ({ data }) => {
  return (
    <>
      {data && data.length ? (
        <TableContainer component={Paper}>
          <Table aria-label="Staff Entitlement Table">
            <TableHead>
              <TableRow>
                <TableCell>Code</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Entitlement</TableCell>
                <TableCell>Used</TableCell>
                <TableCell>Orders in Process</TableCell>
                <TableCell>Returns in Process</TableCell>
                <TableCell>Draft Orders</TableCell>
                <TableCell>Remaining</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((line) => (
                <TableRow
                  key={line.productCode}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {line.productCode}
                  </TableCell>
                  <TableCell>{line.description}</TableCell>
                  <TableCell>{line.entitlement}</TableCell>
                  <TableCell>{line.used}</TableCell>
                  <TableCell>{line.orders}</TableCell>
                  <TableCell>{line.return}</TableCell>
                  <TableCell>{line.draft}</TableCell>
                  <TableCell>{line.remaining}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <>No Data</>
      )}
    </>
  );
};
